import {remCalc} from '../_utils'

const radius = {
    null: {
        base: 0,
        sm: 0,
        md: 0,
        lg: 0,
    },
    small: {
        base: remCalc(4),
        sm: remCalc(4),
        md: remCalc(4),
        lg: remCalc(4),
    },
    medium: {
        base: remCalc(8),
        sm: remCalc(8),
        md: remCalc(8),
        lg: remCalc(8),
    },
    large: {
        base: remCalc(16),
        sm: remCalc(16),
        md: remCalc(16),
        lg: remCalc(16),
    },
    full: {
        base: remCalc(128),
        sm: remCalc(128),
        md: remCalc(128),
        lg: remCalc(128),
    },
    button: {
        base: remCalc(128),
        sm: remCalc(128),
        md: remCalc(128),
        lg: remCalc(128),
    },
}

export default radius
